/* import __COLOCATED_TEMPLATE__ from './infinite-scroll-item-selector-field.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/browser';
const DEFAULT_PAGE_SIZE = 100;
let InfiniteScrollItemSelectorField = (_class = class InfiniteScrollItemSelectorField extends Component {
  get allowedItemTypes() {
    if (this.args.allowedItemTypes) {
      return this.args.allowedItemTypes;
    }
    return [];
  }
  get label() {
    return this.args.label ?? this.intl.t('sharedUi.items');
  }
  get modalOptions() {
    return {
      title: this.args.title ?? this.intl.t('sharedUi.infiniteScrollItemSelectorField.title'),
      primaryButtonLabel: this.args.primaryButtonLabel ?? this.intl.t('sharedUi.infiniteScrollItemSelectorField.primaryButtonLabel')
    };
  }
  get hasMoreItemsToLoad() {
    return Boolean(this.nextPageToken);
  }
  get itemQueryOptions() {
    return {
      useSearchCatalog: true,
      productTypes: this.allowedItemTypes,
      paginationToken: this.nextPageToken,
      pageSize: this.pageSize,
      includedRelationships: [{
        key: 'itemFeeMemberships',
        includedRelationships: ['fee']
      }]
    };
  }
  get itemsLabel() {
    const {
      selectedOptionIds,
      deselectedOptionIds,
      selectedAllOptions,
      deselectedAllOptions
    } = this.itemSelectionState;
    if (selectedAllOptions && deselectedOptionIds.size === 0) {
      return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.allItems');
    }
    if (deselectedAllOptions && selectedOptionIds.size === 0) {
      return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.noItems');
    }
    if (selectedAllOptions && deselectedOptionIds.size > 0) {
      return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.multipleItems');
    }
    if (deselectedAllOptions && selectedOptionIds.size > 0) {
      return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.itemsCount', {
        count: selectedOptionIds.size
      });
    }
    if (selectedOptionIds.size > 0) {
      if (!this.hasMoreItemsToLoad && selectedOptionIds.size === this.itemOptions.length) {
        return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.allItems');
      } else if (selectedOptionIds.size === 1) {
        return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.oneItem');
      } else {
        return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.itemsCount', {
          count: selectedOptionIds.size
        });
      }
    }
    return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.noItems');
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "itemOptions", _descriptor2, this);
    _initializerDefineProperty(this, "nextPageToken", _descriptor3, this);
    _initializerDefineProperty(this, "pageSize", _descriptor4, this);
    _initializerDefineProperty(this, "showItemSelectionModal", _descriptor5, this);
    _initializerDefineProperty(this, "store", _descriptor6, this);
    _initializerDefineProperty(this, "intl", _descriptor7, this);
    _initializerDefineProperty(this, "itemSelectionState", _descriptor8, this);
    this.itemSelectionState = {
      ...this.args.selectionState,
      selectedOptionIds: new Set(this.args.selectionState.selectedOptionIds),
      deselectedOptionIds: new Set(this.args.selectionState.deselectedOptionIds)
    };
  }
  async open() {
    if (this.isLoading) {
      return;
    }
    try {
      this.showItemSelectionModal = true;
      this.isLoading = true;
      if (this.itemOptions.length === 0) {
        await this.loadItemOptions();
      }
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      this.isLoading = false;
    }
  }
  confirm(selectionState) {
    this.itemSelectionState = {
      ...selectionState,
      selectedOptionIds: new Set(selectionState.selectedOptionIds),
      deselectedOptionIds: new Set(selectionState.deselectedOptionIds)
    };
    this.showItemSelectionModal = false;
    this.args.onConfirm(selectionState);
  }
  close() {
    this.showItemSelectionModal = false;
  }
  async loadItemOptions() {
    const response = await this.store.query('item', this.itemQueryOptions);
    this.nextPageToken = response.meta.nextPageToken;
    const newItemOptions = response.toArray().sort(this.itemCompareFn).map(this.createItemOption.bind(this));
    this.itemOptions = [...this.itemOptions, ...newItemOptions];
    this.deriveItemSelectionState(newItemOptions);
  }
  deriveItemSelectionState(itemOptions) {
    this.itemSelectionState = itemOptions.reduce((selectionState, itemOption) => {
      if (itemOption.checked) {
        selectionState.selectedOptionIds.add(itemOption.id);
      }
      return selectionState;
    }, {
      ...this.itemSelectionState
    });
  }
  createItemOption(item) {
    const option = {
      id: item.id,
      value: item,
      label: item.name,
      checked: this.args.isItemSelected(item)
    };
    if (this.args.isItemDisabled) {
      const {
        disabled,
        reason
      } = this.args.isItemDisabled(item);
      option.disabled = disabled;
      option.labelTertiary = reason;
    }
    return option;
  }
  itemCompareFn(itemOne, itemTwo) {
    const itemOneName = itemOne.name.toUpperCase();
    const itemTwoName = itemTwo.name.toUpperCase();
    if (itemOneName < itemTwoName) {
      return -1;
    } else if (itemOneName > itemTwoName) {
      return 1;
    } else {
      return 0;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "itemOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "nextPageToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pageSize", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.pageSize ?? DEFAULT_PAGE_SIZE;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showItemSelectionModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "itemSelectionState", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      selectedOptionIds: new Set(),
      deselectedOptionIds: new Set(),
      selectedAllOptions: false,
      deselectedAllOptions: false
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadItemOptions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadItemOptions"), _class.prototype)), _class);
export { InfiniteScrollItemSelectorField as default };